<template>
  <div class="comps-carda-item"
    @click="$emit('click')">
    <div class="backimg centerimage" ref="backimg"
      :style="'background-image: url(' + imgurl + '); height: ' + height"><!-- 背景图 --></div>
    <h2>{{title}}</h2>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: 'https://www.phocus.com.cn/rongying/web/static/img/5a683d96d2024e4a4f6f76b83a5ab3e.jpg'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      height: '213px'
    }
  },
  mounted () {
    if (this.$refs.backimg.clientWidth) {
      this.height = (this.$refs.backimg.clientWidth / 100 * 50 + 'px')
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
  .comps-carda-item {
    width: 100%;
    .backimg {
      width: 100%;
      height: 50%;
    }
    h2 {
      margin: 20px 0 0;
      font-family: Georgia, 宋体;
      font-weight: bold;
      text-align: center;
    }
  }
  .comps-carda-item:hover {
    cursor: pointer;
    h2 {
      color: @primary;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardIndustriesB.vue